/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { inject as service } from '@ember/service';
import { or } from '@ember/object/computed';
import Component from '@ember/component';
import { task } from 'ember-concurrency';

@tagName('')
export default class Exit extends Component {
  @service api;
  @service apiErrors;
  @service actionSubjects;
  @service store;

  actionAbstract = null;
  isAddingOrMoving = false;
  onSelect() {}
  onDeselect() {}
  vwbContext = null;

  @or('_saveMessage.isRunning', '_deleteMessage.isRunning') _isSaving;

  _saveMessage = task(
    {
      drop: true,
    },
    async () => {
      try {
        await this.actionAbstract.saveTask.perform();
        await this.actionAbstract.action.campaign.parseTree();
        this.onDeselect();
      } catch (e) {
        this.apiErrors.report(e);
        throw e;
      }
    },
  );

  _deleteMessage = task(
    {
      drop: true,
    },
    async () => {
      try {
        await this.actionAbstract.deleteTask.perform();
        this.onDeselect();
      } catch (e) {
        this.apiErrors.report(e);
        throw e;
      }
    },
  );
}
